var MuiSwitch = {
    /* put your new default props here */
    disableRipple: true,
    color: 'secondary',
};
export default MuiSwitch;
//# sourceMappingURL=MuiSwitch.js.map